var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _circle, _circle2, _circle3, _g11, _path, _path2, _path3, _g12, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g13, _path12, _use, _path13, _path14, _ellipse, _path15, _path16, _path17, _path18, _path19, _path20, _g14, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g15, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _g16, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaymentverificationbanner = function SvgPaymentverificationbanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 900 600"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".paymentverificationbanner_svg__N{fill:#faa31a}.paymentverificationbanner_svg__O{fill:#ffcd05}.paymentverificationbanner_svg__P{fill:#00306f}.paymentverificationbanner_svg__Q{fill:#00bdf7}.paymentverificationbanner_svg__R{fill:#0c88cc}.paymentverificationbanner_svg__S{fill:#ffcc01}.paymentverificationbanner_svg__T{fill:#e7f5f7}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "paymentverificationbanner_svg__N"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M655.5 597.4h111.1c7.9 0 14.4-6.5 14.4-14.4v-5.8c0-7.9-6.5-14.4-14.4-14.4H655.5c-7.9 0-14.4 6.5-14.4 14.4v5.8c0 7.9 6.5 14.4 14.4 14.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.9 595.5h114.3c7 0 12.8-5.8 12.8-12.8v-5.2c0-7-5.8-12.8-12.8-12.8H653.9c-7 0-12.8 5.8-12.8 12.8v5.2c0 7 5.7 12.8 12.8 12.8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "paymentverificationbanner_svg__O"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__B",
    x: -8.3
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__B",
    x: -16.6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__C"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__B",
    x: -33.3
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__B",
    x: -41.6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__B",
    x: -49.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.6 593.4c1.3 0 2.4-1.1 2.4-2.4v-21.8c0-1.3-1.1-2.4-2.4-2.4s-2.4 1.1-2.4 2.4V591c0 1.3 1 2.4 2.4 2.4"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__C",
    x: -41.6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__B",
    x: -74.9
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__B",
    x: -83.2
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__B",
    x: -91.5
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__C",
    x: -74.9
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__B",
    x: -108.2
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__B",
    x: -116.5
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__B",
    x: -124.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "paymentverificationbanner_svg__N"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M662.2 564h111.1c7.9 0 14.4-6.5 14.4-14.4v-5.8c0-7.9-6.5-14.4-14.4-14.4H662.2c-7.9 0-14.4 6.5-14.4 14.4v5.8c0 7.9 6.5 14.4 14.4 14.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.6 562.1h114.3c7 0 12.8-5.8 12.8-12.8v-5.2c0-7-5.8-12.8-12.8-12.8H660.6c-7 0-12.8 5.8-12.8 12.8v5.2c0 7 5.8 12.8 12.8 12.8"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "paymentverificationbanner_svg__O"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__D"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -8.3
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -16.6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -24.9
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__F"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -41.6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -49.9
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -58.2
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__D",
    x: -74.9
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -74.9
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -83.2
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -91.5
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -99.8
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__F",
    x: -74.9
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -116.5
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "paymentverificationbanner_svg__N"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M656.3 531.7h111.1c7.9 0 14.4-6.5 14.4-14.4v-5.8c0-7.9-6.5-14.4-14.4-14.4H656.3c-7.9 0-14.4 6.5-14.4 14.4v5.8c0 7.9 6.4 14.4 14.4 14.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.7 529.7H769c7 0 12.8-5.8 12.8-12.8v-5.2c0-7-5.8-12.8-12.8-12.8H654.7c-7 0-12.8 5.8-12.8 12.8v5.2a12.76 12.76 0 0 0 12.8 12.8"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "paymentverificationbanner_svg__O"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__G"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__G",
    x: -8.3
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__H"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__G",
    x: -25
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__G",
    x: -33.3
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__G",
    x: -41.6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__I"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__H",
    x: -41.6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__G",
    x: -66.6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__G",
    x: -74.9
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__G",
    x: -83.2
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__H",
    x: -74.9
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__G",
    x: -99.9
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__G",
    x: -108.2
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__G",
    x: -116.5
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__I",
    x: -74.9
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "paymentverificationbanner_svg__N"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M556.5 459.7h111.1c7.9 0 14.4-6.5 14.4-14.4v-5.8c0-7.9-6.5-14.4-14.4-14.4H556.5c-7.9 0-14.4 6.5-14.4 14.4v5.8c0 7.9 6.4 14.4 14.4 14.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.9 457.8h114.3c7 0 12.8-5.8 12.8-12.8v-5.2c0-7-5.8-12.8-12.8-12.8H554.9c-7 0-12.8 5.8-12.8 12.8v5.2c0 7 5.7 12.8 12.8 12.8"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "paymentverificationbanner_svg__O"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -97.4,
    y: -104.3
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -105.7,
    y: -104.3
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__F",
    x: -80.8,
    y: -104.3
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -122.4,
    y: -104.3
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -130.7,
    y: -104.3
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -139,
    y: -104.3
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__D",
    x: -155.7,
    y: -104.3
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__F",
    x: -122.4,
    y: -104.3
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -164,
    y: -104.3
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -172.3,
    y: -104.3
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -180.6,
    y: -104.3
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__F",
    x: -155.7,
    y: -104.3
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -197.3,
    y: -104.3
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -205.6,
    y: -104.3
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -213.9,
    y: -104.3
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__D",
    x: -230.6,
    y: -104.3
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "paymentverificationbanner_svg__N"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M561 425.1h111.1c7.9 0 14.4-6.5 14.4-14.4v-5.8c0-7.9-6.5-14.4-14.4-14.4H561c-7.9 0-14.4 6.5-14.4 14.4v5.8a14.34 14.34 0 0 0 14.4 14.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.4 423.2h114.3c7 0 12.8-5.8 12.8-12.8v-5.2c0-7-5.8-12.8-12.8-12.8H559.4c-7 0-12.8 5.8-12.8 12.8v5.2c0 7 5.7 12.8 12.8 12.8"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    className: "paymentverificationbanner_svg__O"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -92.9,
    y: -138.9
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -101.2,
    y: -138.9
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__D",
    x: -117.9,
    y: -138.9
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__F",
    x: -84.6,
    y: -138.9
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -126.2,
    y: -138.9
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -134.5,
    y: -138.9
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -142.8,
    y: -138.9
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__F",
    x: -117.9,
    y: -138.9
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -159.5,
    y: -138.9
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -167.8,
    y: -138.9
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -176.1,
    y: -138.9
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__D",
    x: -192.8,
    y: -138.9
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__F",
    x: -159.5,
    y: -138.9
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -201.1,
    y: -138.9
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -209.4,
    y: -138.9
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -217.7,
    y: -138.9
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    className: "paymentverificationbanner_svg__N"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M542.7 391.8h111.1c7.9 0 14.4-6.5 14.4-14.4v-5.8c0-7.9-6.5-14.4-14.4-14.4H542.7c-7.9 0-14.4 6.5-14.4 14.4v5.8c0 7.9 6.5 14.4 14.4 14.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.1 389.9h114.3c7 0 12.8-5.8 12.8-12.8v-5.2c0-7-5.8-12.8-12.8-12.8H541.1c-7 0-12.8 5.8-12.8 12.8v5.2c0 7 5.8 12.8 12.8 12.8"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "paymentverificationbanner_svg__O"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -111.1,
    y: -172.2
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__D",
    x: -127.8,
    y: -172.2
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -127.8,
    y: -172.2
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -136.1,
    y: -172.2
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -144.4,
    y: -172.2
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -152.7,
    y: -172.2
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__F",
    x: -127.8,
    y: -172.2
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -169.4,
    y: -172.2
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -177.7,
    y: -172.2
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -186,
    y: -172.2
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__D",
    x: -202.7,
    y: -172.2
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -202.7,
    y: -172.2
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -211,
    y: -172.2
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -219.3,
    y: -172.2
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__E",
    x: -227.6,
    y: -172.2
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__F",
    x: -202.7,
    y: -172.2
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 654.4,
    cy: 491.9,
    r: 79.9,
    className: "paymentverificationbanner_svg__N"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 654.4,
    cy: 491.9,
    r: 76,
    className: "paymentverificationbanner_svg__O"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 654.4,
    cy: 491.8,
    r: 63,
    fill: "#e68913",
    transform: "rotate(-45.001 654.378 491.856)"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "paymentverificationbanner_svg__N"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 654.8,
    cy: 493.9,
    r: 61.8,
    transform: "rotate(-45.001 654.805 493.86)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.7 442.9h5.4a2.69 2.69 0 0 1 2.7 2.7v3.9c4.6.4 9 1.6 12.9 3.5 5.4 2.5 7 9.5 3.2 14.2-2.9 3.6-8 4.5-12 2.2-1.6-1-3.1-1.6-4.4-2V486c16.4 5 24.5 14.2 24.5 27.7 0 14.3-9.2 23.5-24.7 26.3v3.7c0 1.6-1.3 2.9-2.9 2.9h-4.7c-1.6 0-2.9-1.3-2.9-2.9v-3.6c-7.2 0-14.3-2.2-19.9-5.5-4.7-2.7-5.8-9.1-2.4-13.4 2.9-3.6 8.1-4.4 12-1.9 3.2 2 6.6 3.3 10.3 4.1v-21.6c-34.1-8.6-30.5-50.8.1-52.2v-3.7c.1-1.8 1.3-3 2.8-3m-2.8 39.6v-15.8c-8.4 2.8-7.8 13 0 15.8m10.6 22.8V522c8.7-2.1 9.4-13.3 0-16.7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M659 440.6h5.4a2.69 2.69 0 0 1 2.7 2.7v3.9c4.6.4 9 1.6 12.9 3.5 5.4 2.5 7 9.5 3.2 14.2-2.9 3.6-8 4.5-12 2.2-1.6-1-3.1-1.6-4.4-2v18.6c16.4 5 24.5 14.2 24.5 27.7 0 14.3-9.2 23.5-24.7 26.3v3.7c0 1.6-1.3 2.9-2.9 2.9H659c-1.6 0-2.9-1.3-2.9-2.9v-3.6c-7.2 0-14.3-2.2-19.9-5.5-4.7-2.7-5.8-9.1-2.4-13.4 2.9-3.6 8.1-4.4 12-1.9 3.2 2 6.6 3.3 10.3 4.1v-21.6c-34.1-8.6-30.5-50.8.1-52.2v-3.7c.1-1.8 1.3-3 2.8-3m-2.8 39.6v-15.8c-8.4 2.8-7.8 13 0 15.8m10.6 22.8v16.7c8.7-2.1 9.4-13.3 0-16.7",
    className: "paymentverificationbanner_svg__O"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M634.4 597.9H400.3c-4.7 0-8.6-3.7-9.1-8.6l-44.7-439.4c-.6-5.7 3.7-10.7 9.1-10.7h234.1c4.7 0 8.6 3.7 9.1 8.6l44.7 439.4c.6 5.7-3.7 10.7-9.1 10.7",
    className: "paymentverificationbanner_svg__R"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M619.7 569.4H414.4c-4.3 0-7.9-3.2-8.3-7.5l-44-396.2c-.5-5 3.3-9.3 8.3-9.3h205.3c4.3 0 7.9 3.2 8.3 7.5l44 396.2c.5 4.9-3.3 9.3-8.3 9.3",
    className: "paymentverificationbanner_svg__T"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "paymentverificationbanner_svg__P"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M532.9 585.3h-41.7c-1.3 0-2.3-1.1-2.3-2.4s1-2.4 2.3-2.4h41.7c1.3 0 2.3 1.1 2.3 2.4s-1.1 2.4-2.3 2.4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 492.8,
    cy: 147.9,
    rx: 3,
    ry: 3.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 504.5,
    cy: 147.9,
    rx: 3,
    ry: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.3 151h-32c-1.6 0-3-1.4-3-3.1s1.3-3.1 3-3.1h32c1.6 0 3 1.4 3 3.1-.1 1.7-1.4 3.1-3 3.1m-8 302.7h117.1L557.5 231c-.3-2.7-2.7-4.9-5.3-4.9H413.6c-2.6 0-4.4 2.2-4.1 4.9l22.1 190.1c2.1 18 17.6 32.6 34.7 32.6"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M469 447.4h112l-24.8-212.7c-.3-2.6-2.5-4.7-5-4.7H418.8c-2.5 0-4.2 2.1-3.9 4.7L436 416.4c2 17.1 16.8 31 33 31",
    className: "paymentverificationbanner_svg__T"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m492.6 402.8-.5-3.9c-.4-3.1 1.4-5.6 3.9-5.6h142c2.5 0 4.9 2.5 5.3 5.6l.5 3.9c3.2 27.8-12.7 50.3-35.5 50.3h-145c22.8 0 33.2-20 29.3-50.3",
    className: "paymentverificationbanner_svg__P"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m496.6 406.7-.4-3.2c-.3-2.5 1.4-4.5 3.8-4.5h132.8c2.4 0 4.5 2 4.8 4.5l.4 3.2c2.6 22.5-12.6 40.7-34 40.7H462.6c21.4 0 37.4-10.9 34-40.7",
    className: "paymentverificationbanner_svg__T"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M452.6 345.3h100.3c1.4 0 2.4-1.2 2.3-2.7-.2-1.5-1.5-2.7-2.9-2.7H452c-1.4 0-2.4 1.2-2.3 2.7.2 1.5 1.5 2.7 2.9 2.7m1.1 10H554c1.4 0 2.4-1.2 2.3-2.7-.2-1.5-1.5-2.7-2.9-2.7H453.1c-1.4 0-2.4 1.2-2.3 2.7.2 1.5 1.5 2.7 2.9 2.7m1.2 9.6h100.3c1.4 0 2.4-1.2 2.3-2.7s-1.5-2.7-2.9-2.7H454.2c-1.4 0-2.4 1.2-2.3 2.7.2 1.5 1.5 2.7 3 2.7",
    className: "paymentverificationbanner_svg__N"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M493.4 309.2h-56c-1.1 0-2.1-.9-2.2-2.1l-6.9-58.9c-.1-1.2.6-2.1 1.7-2.1h56c1.1 0 2.1.9 2.2 2.1l6.9 58.9c.2 1.1-.6 2.1-1.7 2.1",
    className: "paymentverificationbanner_svg__S"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M491.3 307.1H439c-1 0-2-.9-2.1-1.9l-6.4-55c-.1-1.1.6-1.9 1.6-1.9h52.3c1 0 2 .9 2.1 1.9l6.4 55c.2 1-.5 1.9-1.6 1.9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M448.6 266.4h-18.9c-.9 0-1.7-.8-1.8-1.7l-2.3-19.9c-.1-.9.5-1.7 1.4-1.7h18.9c.9 0 1.7.8 1.8 1.7l2.3 19.9c.2.9-.5 1.7-1.4 1.7",
    className: "paymentverificationbanner_svg__N"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M445.2 263.1h-12.8c-.9 0-1.7-.8-1.8-1.7L429 248c-.1-.9.5-1.7 1.4-1.7h12.8c.9 0 1.7.8 1.8 1.7l1.6 13.5c.1.9-.5 1.6-1.4 1.6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M442.2 260.3h-7.4c-.9 0-1.7-.8-1.8-1.7l-.9-7.8c-.1-.9.5-1.7 1.4-1.7h7.4c.9 0 1.7.8 1.8 1.7l.9 7.8c.1.9-.5 1.7-1.4 1.7m7.8 48.9h-13.9c-.6 0-1.2-.6-1.3-1.2l-1.7-14.6c-.1-.7.4-1.2 1-1.2H448c.6 0 1.2.6 1.3 1.2L451 308c.1.6-.3 1.2-1 1.2",
    className: "paymentverificationbanner_svg__N"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M447.5 306.8h-9.4c-.6 0-1.2-.6-1.3-1.2l-1.2-9.9c-.1-.7.4-1.2 1-1.2h9.4c.6 0 1.2.6 1.3 1.2l1.2 9.9c.1.6-.4 1.2-1 1.2"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "paymentverificationbanner_svg__N"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__J"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.9 263.3H475c-.6 0-1.2-.6-1.3-1.2l-1.7-14.6c-.1-.7.4-1.2 1-1.2h13.9c.6 0 1.2.6 1.3 1.2l1.7 14.6c.1.6-.3 1.2-1 1.2"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M486.4 260.9H477c-.6 0-1.2-.6-1.3-1.2l-1.2-9.9c-.1-.7.4-1.2 1-1.2h9.4c.6 0 1.2.6 1.3 1.2l1.2 9.9c.1.6-.4 1.2-1 1.2"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__J",
    x: 38.9,
    y: -45.9,
    className: "paymentverificationbanner_svg__N"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M493 288.6h-4.2l-.4-3.5h-2.7l.8 7.1h-2.9l-1.4-11.8h1.7l-.3-2.8h-1.7l-.8-6.5h4.6l-.3-2.7h-4.6l-.4-3.5h-2.7l.4 3.5h-6.8l-.2-2h4.5l-.2-1.7h-4.5l-1.2-10h-3.5l1.2 10h-1.7l-1.2-10.7h2.1l-.9-7.8h-7.4l.9 7.8h3l.1.7h-7.8l-.4-3.3h4.4l-.2-2h-4.4l-.4-3.1H451l1 8.5h-4l.4 3.3h1l1.5 13.1h-6.3l-.7-6.4h-2.6l.7 6.4h-2.6l-.1-1.1H431l1 8.7h8.3l-.5-4.4h2.6l.9 8.1H436l.3 2.7h7.2l.3 2.6h2.6l-.3-2.6h3.7l.4 3.4h3.2l-.4-3.4h5l.9 7.9h-7.5l1.1 9.5h7.4l.4 3.4h-5l.4 3.2h7.2l-.8-6.6h1.1l-.2-1.9h-6.2l-.6-4.9h2.9l.1 1.1h2.2l-.1-1.1h3.2l-.3-2.7H461l-.9-7.9h6.9l1.4 11.7h3.3l-.2-1.9h4.5l.4 3.8h-10.8l.4 3.8h8.1l.8 6.6h3.3l-.8-6.6h2.1l-.3-2.4-.2-1.5-.4-3.8h2.4l.4 3.4.2 1.5.4 3.2h5.1l.4 3.8h-5.1l.3 2.4h7.1l-.7-6.2h1.1l-.5-4.7h-5.6l-.4-3.4h5.6l-.2-2.1h4.2zm-21.4-17.5h6.8l.8 6.5h-6.8zm-4-4.7.2 2h-1.7l-.2-2zm-9.9 16h-5l-.2-2h5zm-.6-4.8h-8.2l.1.8.2 2 .2 2h-3.7l-.9-8.1h11.9zm-.9-8.3.2 1.8h-2.2l-.5-4.7h4.5l-.4-3.4h-4.5l-.6-5h4.5l.4 3.4h4l-.6-3.4h1.6l.8 6.7h-1.6l.2 1.7h1.6l.2 2h-3.1l.3 2.7h3.1l.4 3.3h2.2l-.4-3.3h1.7l.8 6.5h-9.5l-1-8.3zm22.4 22.9-.3-2.2h-2.7l.3 2.2h-4.5l-.8-7.1h3.3l-.3-2.7H460l-.2-2h19.9l1.4 11.8z",
    className: "paymentverificationbanner_svg__S"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M472.5 169.8c.7-.3 1.6-.3 2.5 0l58.8 23.1 43.2 17c3.6 1.4 3.7 6.6.1 6.6h-188c-3.6 0-5.6-5.2-2.6-6.6l36.5-17z",
    className: "paymentverificationbanner_svg__P"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 478.5,
    cy: 193.5,
    className: "paymentverificationbanner_svg__S",
    rx: 11.9,
    ry: 14.7,
    transform: "rotate(-41.031 478.472 193.472)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M484.2 195.7c.3 1.5.1 2.8-.5 3.8s-1.7 1.6-3.1 1.8l.5 2.3-.1.1h-.9l-.1-.1-.5-2.3c-1.5 0-3-.3-4.5-1l-.1-.2c0-.9-.2-2.1-.5-3.6l.1-.1h.7l.2.1.2.9c.1.4.2.7.4 1.1.9.9 2 1.4 3.4 1.5l-1.2-5.9c-1.6-.3-2.7-.7-3.5-1.3-1-.8-1.6-1.8-1.9-3.2-.4-1.9.1-3.3 1.3-4.3.6-.4 1.3-.7 2.2-.8l-.2-1.2.1-.1h.8l.2.1.2 1.2q2.25.15 3.9.9l.1.2c0 .4.1 1.2.2 2.3l.1 1-.1.1h-.7l-.1-.1c-.1-.4-.2-.7-.2-.9-.1-.5-.2-.8-.3-1q-.9-1.05-2.7-1.2l1.1 5.3q2.4.3 3.6 1.2c.9.8 1.6 1.9 1.9 3.4m-6.8-4.7-1-5.1q-1.95.6-1.5 2.7c.3 1.3 1.1 2.1 2.5 2.4m4.6 6c-.3-1.5-1.2-2.3-2.8-2.6l1.1 5.6c.6-.2 1.1-.6 1.4-1.1.4-.5.4-1.2.3-1.9",
    className: "paymentverificationbanner_svg__N"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M387.5 222.1h15.9l19.9 165.4-20.7.2zm173.8 1.2h16l19.2 160.4-16.8.3zM377 598.2H199.1c-28.1 0-50.8-22.8-50.8-50.8v-85.2c0-28.1 22.8-50.8 50.8-50.8H377c28.1 0 50.8 22.8 50.8 50.8v85.2c.1 28.1-22.7 50.8-50.8 50.8",
    className: "paymentverificationbanner_svg__P"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M371.1 594.9H193.9c-27.7 0-50.2-22.5-50.2-50.2v-83.2c0-27.7 22.5-50.2 50.2-50.2H371c27.7 0 50.2 22.5 50.2 50.2v83.2c.1 27.7-22.4 50.2-50.1 50.2",
    className: "paymentverificationbanner_svg__Q"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M391.6 453h-61.1c-6.3 0-11.4-5.9-11.4-13.2s5.1-13.2 11.4-13.2h61.1c6.3 0 11.4 5.9 11.4 13.2 0 7.2-5.1 13.2-11.4 13.2",
    className: "paymentverificationbanner_svg__R"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M369.1 552.3c0 11.1-7.7 20.1-17.3 20.1-9.5 0-17.3-9-17.3-20.1s7.7-20.1 17.3-20.1c9.5.1 17.3 9.1 17.3 20.1",
    className: "paymentverificationbanner_svg__N"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M392.6 552.3c0 11.1-7.7 20.1-17.3 20.1-9.5 0-17.3-9-17.3-20.1s7.7-20.1 17.3-20.1c9.6.1 17.3 9.1 17.3 20.1",
    className: "paymentverificationbanner_svg__S"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "paymentverificationbanner_svg__R"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__K"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__L"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__K",
    x: 118.5
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paymentverificationbanner_svg__L",
    x: 118.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.3 550.7H169.6c-3.4 0-6.2-2.8-6.2-6.2v-4.9c0-3.4 2.8-6.2 6.2-6.2h106.7c3.4 0 6.2 2.8 6.2 6.2v4.9c0 3.5-2.8 6.2-6.2 6.2m-31.5 21.7h-75.2c-3.4 0-6.2-2.8-6.2-6.2v-4.9c0-3.4 2.8-6.2 6.2-6.2h75.2c3.4 0 6.2 2.8 6.2 6.2v4.9c0 3.4-2.8 6.2-6.2 6.2"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M817.6 303.2c-15.6-21.7-23-29.9-23.5-35.2v-.6c0-5.3 6.4-27.8 6.4-27.8l-13-8.6s0 .1-.1.4c0 .1-.1.2-.1.4v.1c0 .1-.1.2-.1.4 0 .1 0 .2-.1.3 0 .1-.1.3-.1.4s-.1.2-.1.3c-.1.2-.1.4-.2.6 0 .1-.1.2-.1.3-.1.2-.1.4-.2.7 0 .2-.1.3-.1.5-.1.2-.1.5-.2.7 0 .2-.1.3-.1.5-.1.3-.2.5-.2.8-.1.2-.1.3-.2.5l-.3.9c-.1.2-.1.4-.2.6l-.3.9c-.1.2-.1.4-.2.6-.1.3-.2.6-.3 1-.1.2-.1.4-.2.7l-.3.9c-.1.3-.2.5-.2.8l-.3.9c-.1.3-.2.5-.3.8s-.2.7-.3 1-.2.6-.3.8c-.1.3-.2.7-.3 1-3.4 10.9-7.8 24.2-11.2 31.8-6.6 14.6-9.9 41.7-8.6 89.4s-7.9 46.3 6 52.3 63.6-4 70.2-19.2c6.6-15.1-4.5-77.1-20.9-99.9",
    className: "paymentverificationbanner_svg__Q"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M848.4 580.3s20.9 2.3 25.8 0c5-2.3 6.6 3-6.3 9.5s-18.5 11.4-22.8 9.7-7.3-10-6.6-14.7c.6-4.9 9.9-4.5 9.9-4.5m-94.3-9.5s-1 15.9 4 19.2 11 7.8-.7 7.8c-11.6 0-14.7-5.5-18.4-11.1-3.6-5.6-7.4-10-2.2-13.8s5.4-7.4 6.4-7.4 10.9 5.3 10.9 5.3",
    className: "paymentverificationbanner_svg__P"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M823.5 428.5c0 93.3-70.5 155-70.5 155s-14.3-9.3-14.8-15.3 27.6-41.9 27.6-73.7v-95.8z",
    className: "paymentverificationbanner_svg__R"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M765.9 398.7v79.2c12.3 28.3 17 50.6 17.5 70.3 18.7-28 40.1-67.1 40.1-119.7z",
    className: "paymentverificationbanner_svg__P"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M766 382.8c-1.5 77.9 66.3 204.6 70.9 206.5 4.7 2 17.8-4.6 17.1-9.4-18-114.2-21.4-190.2-21.4-190.2z",
    className: "paymentverificationbanner_svg__R"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#255096",
    d: "M840.4 283.8s3.6 3.3 8 1.2c4.5-2.2 20.8-13.7 20.3-16.5s-8.1-3.5-8.1-3.5-23.6 18.6-20.2 18.8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M825 297.7s5.9-9.9 8.7-12.6c2.8-2.6 12.3-7.8 13.8-7.8 2.5-.1-8.5 7.3-8.5 7.3s1.5 9.6.2 13.1-15.2 8.1-15.2 8.1z",
    className: "paymentverificationbanner_svg__Q"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "paymentverificationbanner_svg__S"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M814 308.2s9.6-14.4 11.8-13.4 7.9 13.4 7.9 13.4-16.9 17.5-16.9 14.2c.1-3.3-2.8-14.2-2.8-14.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m817.6 303.2-6.8-9.3c-2.9-5.3-5-15.2-5.2-17.8s-35.6-16.6-35.7-13.9c-.3 5.4-2.6 23.5-4.5 38.4-.7 4.1-1.3 8.8-1.8 13.8v.3c-1.4 14.3-1.8 32.5-1.2 55.4 1.3 47.7-7.9 46.3 6 52.3s63.6-4 70.2-19.2c6.5-15.2-4.6-77.2-21-100"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M824 248.2c-2.8 12.5-11.4 21.3-21.3 18.9-7.3-1.8-18.5-12-14.9-26.9 3-12.4 13.1-20.8 23.1-18.6 10 2.3 15.9 14.2 13.1 26.6m11.3 81.3c9-15.6 10-30.2 16.5-34.7 9-6.4 16.4-20.7 13.1-21.3S848.4 285 848.4 285s3.4-4.7 2.6-5.1-7.5 4.4-8.5 10.1-13.8 31.9-24.5 40.3 8.3 14.8 17.3-.8",
    className: "paymentverificationbanner_svg__Q"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M776.8 290.1c-16 4-8.7 52.4 4.8 81 13.5 28.7 38.9 3.9 48.4-3.1 3.6-2.7 6-5.4 7.5-7.7-3-17.1-8.3-35.5-14.7-48.4-15.1 17.8-22.3-27.7-46-21.8",
    className: "paymentverificationbanner_svg__N"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M781.6 286.7c-20.1 2-9.1 52.3 5.6 72.6s35.7.7 42.3-11 20-31.6 20-44.5c0-2.4-5-2.9-10.9-2.5-5.6.4-31 35.3-31 35.3s-8.4-51.7-26-49.9",
    className: "paymentverificationbanner_svg__S"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M830.2 222.2c12.3 5.2 4.9 21.6-1.6 22.2s-14-11.4-17.9-11.8.8 6.7-2.7 8.3c-3.4 1.6-6.6 4.3-7.6 8.6s-3.7 13.5.7 13.9c4.5.4 9.4-4.5 12.4-4.7s5.7.7 5.7.7-7.7 10.7-13.4 11.3-11.9-7.7-16.3-14.7-2.5-11.7-2.5-11.7-4.5 5.1-7.4 4.7c-2.8-.4 4.3-4.5 4.5-16.4.2-12 5.5-18.3 12-18.3s5.7-3.3 15.6-3c9 .3 15.6 9.7 18.5 10.9",
    className: "paymentverificationbanner_svg__P"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M803.1 246.7c.3 3.1-1.3 5.8-3.5 6s-4.3-2.1-4.6-5.2 1.3-5.8 3.5-6c2.3-.2 4.3 2.1 4.6 5.2",
    className: "paymentverificationbanner_svg__Q"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6 579.8c-11.4 12.7-32.7 10.8-29.3 16.3s18.7 4.1 27.4 3.6c14.3-.8 10.4-9 11.5-11.9 1.2-3-9.6-8-9.6-8m96.6-179.4S74.1 455 75 466.3c1 11.2 52.4 104.8 56.7 104.9 4.3 0 14-4.8 15.4-7 1.5-2.2-2.9-67.1-8.2-73.7-5.4-6.6 41.1-73 41.1-73z",
    className: "paymentverificationbanner_svg__P"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M207.1 388.7s16.2 37.1 6.8 47.3c-9.5 10.2-42.7 17.8-53.9 34.6-24.6 37-24.9 63.2-58.5 91.5-33.7 28.3-43.4 29-43.4 29l-11.3-9.9s37.6-51.1 52.2-92.1 53.2-89.3 53.2-89.3z",
    className: "paymentverificationbanner_svg__R"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M140.9 301.4s-3.4 3.2-7.6 1.1c-4.2-2-19.7-13-19.2-15.6.5-2.7 7.7-3.3 7.7-3.3s22.3 17.7 19.1 17.8",
    className: "paymentverificationbanner_svg__N"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M155.5 314.6s-5.6-9.4-8.2-11.9c-2.7-2.5-11.7-7.4-13-7.4-2.3-.1 8 6.9 8 6.9s-1.4 9.1-.2 12.4c1.3 3.3 14.4 7.7 14.4 7.7z",
    className: "paymentverificationbanner_svg__Q"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M165.9 324.5s-9.1-13.6-11.1-12.7-7.5 12.7-7.5 12.7 16 16.6 16 13.5c-.1-3.1 2.6-13.5 2.6-13.5",
    className: "paymentverificationbanner_svg__N"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M191.1 251.4s9.4 33.3 15.7 47.1 9.4 39.5 8.2 84.7c-1.3 45.2 7.5 43.9-5.6 49.6-13.2 5.6-60.2-3.8-66.5-18.2s4.2-73.2 19.8-94.8c15.4-21.3 22.3-28.9 22.3-33.9s-6.1-26.4-6.1-26.4z",
    className: "paymentverificationbanner_svg__Q"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "paymentverificationbanner_svg__O"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.7 414.6c-6.3-14.4 4.2-73.2 19.8-94.8l16.1-21.9c7.5-4.4 15.7-8.6 23.6-11 1.6 4.5 3.1 8.5 4.5 11.6 6.3 13.8 9.4 39.5 8.2 84.7-1.3 45.2 7.5 43.9-5.6 49.6-13.2 5.6-60.3-3.8-66.6-18.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.8 280.9c-.2-2.6-33.7 10.7-33.9 13.2s-2.2 11.9-5 16.9 46.7 33.2 44.9 19.5z"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#00b3dd",
    d: "M184.8 286.5v-.6c0-5-6.1-26.4-6.1-26.4l12.3-8.2 5.2 17.3c-3.8 11.6-7.4 15.5-11.4 17.9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M160 267.7c2.3 10.3 9.4 17.7 17.7 15.7 6.1-1.5 15.4-9.9 12.4-22.3-2.5-10.3-10.9-17.2-19.2-15.4s-13.2 11.6-10.9 22m-14.3 77c-8.6-14.8-9.5-28.6-15.6-32.9-8.5-6.1-15.6-19.7-12.5-20.2s15.6 10.9 15.6 10.9-3.3-4.5-2.5-4.8c.8-.4 7.1 4.2 8.1 9.6s13.1 30.3 23.3 38.2c10.2 8-7.8 14-16.4-.8",
    className: "paymentverificationbanner_svg__Q"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M201.2 307.4c15.2 3.8 8.2 49.6-4.6 76.8s-36.9 3.7-45.9-3c-3.4-2.5-5.7-5.1-7.1-7.3 2.9-16.2 7.8-33.6 13.9-45.9 14.5 16.9 21.3-26.2 43.7-20.6",
    className: "paymentverificationbanner_svg__N"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M196.7 304.1c19.1 1.9 8.6 49.6-5.3 68.8-14 19.2-33.8.6-40.1-10.5s-19-29.9-19-42.2c0-2.3 4.7-2.8 10.4-2.4 5.3.4 29.3 33.5 29.3 33.5s8-48.8 24.7-47.2",
    className: "paymentverificationbanner_svg__O"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 559.4c.9 20.5-22.6 37.1-12.8 38.5 9.8 1.5 17.4-5.1 21.9-10.1s9.3-6.5 8-12.1c-1.3-5.7-1.4-17.6-2.8-21.5s-14.3 5.2-14.3 5.2",
    className: "paymentverificationbanner_svg__P"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M167.6 235.6c-19.9 1.4-17.4 32.3-17.4 32.3s16.4.5 21.3-.9 9.9-5.3 9.9-5.3 3 11.7 11.3 12.4l8.2.7s5.4-22.2 1.1-32.2c-8.8-21-26.6-10.6-34.4-7",
    className: "paymentverificationbanner_svg__R"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M189.3 265.5c-1.2 3-4 4.8-6.2 3.9-2.3-.9-3.1-4.1-2-7.1 1.2-3 4-4.8 6.2-3.9 2.3.9 3.2 4 2 7.1",
    className: "paymentverificationbanner_svg__Q"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M199.2 258.8s4.8 16.5 11.4 17.3 49.1 3.3 38.2 47.8c-7.5 30.9-20.9 36.1-7.4 47.5 11.3 9.5 24.6-2.4 24.6-2.4s6.5 35.4-19.8 34.9-38.9-28.2-28.2-53.6-10.5-31.9-11.4-46.2c-1-15.7 0-22.6 0-22.6l-7.4-8.9z",
    className: "paymentverificationbanner_svg__R"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#21366b",
    d: "M.5 597.2h900v3H.5z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#22366c",
    d: "M515.5 489.5c-10.1 6.3-21.7 23.3-23.2 34l17.7.2c-.2 0-.8-1.8-1.4-5.2l-12.2-.3c-.3 0-.2-.5-.1-.5 2.2-.2 12-.6 12-.6-.3-1.6-.1-5 .2-6.5l-9.3-.2c-.3 0-.4-.3-.1-.3l9.3-.5s.6-4.7 1-6l-5.1-.2c-.2 0-.2-.3-.1-.3l5.5-.3zm-.7 7.9c-3.4 7.5-5.2 20.9-2.4 26.9l16.5 5.3c-4.2-3.8-11.2-13.9-14.1-32.2m-23.3 28.7 39 5.8c-3.8 1.5-19.2 1.6-29.7.6-3-1-7.5-3.6-9.3-6.4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "paymentverificationbanner_svg__B",
    d: "M773.8 593.4c1.3 0 2.4-1.1 2.4-2.4v-21.8c0-1.3-1.1-2.4-2.4-2.4s-2.4 1.1-2.4 2.4V591c0 1.3 1.1 2.4 2.4 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paymentverificationbanner_svg__C",
    d: "M748.8 593.4c1.3 0 2.4-1.1 2.4-2.4v-21.8c0-1.3-1.1-2.4-2.4-2.4s-2.4 1.1-2.4 2.4V591c.1 1.3 1.1 2.4 2.4 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paymentverificationbanner_svg__D",
    d: "M780.6 560c1.3 0 2.4-1.1 2.4-2.4v-21.8c0-1.3-1.1-2.4-2.4-2.4s-2.4 1.1-2.4 2.4v21.8c0 1.3 1 2.4 2.4 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paymentverificationbanner_svg__E",
    d: "M772.2 560c1.3 0 2.4-1.1 2.4-2.4v-21.8c0-1.3-1.1-2.4-2.4-2.4s-2.4 1.1-2.4 2.4v21.8c0 1.3 1.1 2.4 2.4 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paymentverificationbanner_svg__F",
    d: "M738.9 560c1.3 0 2.4-1.1 2.4-2.4v-21.8c0-1.3-1.1-2.4-2.4-2.4s-2.4 1.1-2.4 2.4v21.8c.1 1.3 1.1 2.4 2.4 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paymentverificationbanner_svg__G",
    d: "M774.6 527.6c1.3 0 2.4-1.1 2.4-2.4v-21.8c0-1.3-1.1-2.4-2.4-2.4s-2.4 1.1-2.4 2.4v21.8c0 1.4 1.1 2.4 2.4 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paymentverificationbanner_svg__H",
    d: "M757.9 527.6c1.3 0 2.4-1.1 2.4-2.4v-21.8c0-1.3-1.1-2.4-2.4-2.4s-2.4 1.1-2.4 2.4v21.8c.1 1.4 1.1 2.4 2.4 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paymentverificationbanner_svg__I",
    d: "M724.7 527.6c1.3 0 2.4-1.1 2.4-2.4v-21.8c0-1.3-1.1-2.4-2.4-2.4s-2.4 1.1-2.4 2.4v21.8c0 1.4 1 2.4 2.4 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paymentverificationbanner_svg__J",
    d: "M445.3 304.7h-5.4c-.6 0-1.2-.6-1.3-1.2l-.7-5.7c-.1-.7.4-1.2 1-1.2h5.4c.6 0 1.2.6 1.3 1.2l.7 5.7c.1.7-.4 1.2-1 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paymentverificationbanner_svg__K",
    d: "M209.7 503.3h-38.1c-4.5 0-8.1-3.6-8.1-8.1v-6.4c0-4.5 3.6-8.1 8.1-8.1h38.1c4.5 0 8.1 3.6 8.1 8.1v6.4c0 4.5-3.7 8.1-8.1 8.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paymentverificationbanner_svg__L",
    d: "M268.9 503.3h-38.1c-4.5 0-8.1-3.6-8.1-8.1v-6.4c0-4.5 3.6-8.1 8.1-8.1h38.1c4.5 0 8.1 3.6 8.1 8.1v6.4c0 4.5-3.6 8.1-8.1 8.1"
  }))));
};
export default SvgPaymentverificationbanner;